module.exports = __webpack_public_path__ + "img/facebook-icon.047d05c3.svg";